/// Conta corrente termina em dígito verificador. A máscara aplica o hífen enquanto se digita para
/// o operador conferir o dígito na hora; quem grava o formato definitivo é o servidor. `X` é aceito
/// porque alguns bancos usam a letra como verificador.
export function maskAccountNumber(value: string): string {
  const digits = value.toUpperCase().replace(/[^0-9X]/gu, '');
  if (digits.length <= 1) return digits;
  return `${digits.slice(0, -1)}-${digits.slice(-1)}`;
}
